(function () {
  function readState() {
    var el = document.querySelector('[data-variant-discount-state]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      case 'amount':
      default: value = fmt(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function pickTier(tiers, qty) {
    var chosen = null;
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      if (qty >= t.minQty && (chosen === null || t.minQty > chosen.minQty)) {
        chosen = t;
      }
    }
    return chosen;
  }

  function getCurrentQty() {
    var input = document.querySelector('[data-quantity-input]');
    if (!input) return 1;
    var v = parseInt(input.value, 10);
    return isNaN(v) || v < 1 ? 1 : v;
  }

  function applyState(variantId, qty) {
    var state = readState();
    if (!state || variantId == null) return;
    var entry = state[String(variantId)];
    if (!entry) return;

    var badges = document.querySelectorAll('[data-pdp-discount-badge]');
    var prices = document.querySelectorAll('[data-price]');
    var compares = document.querySelectorAll('[data-compare-price]');
    var badgeLabels = document.querySelectorAll('[data-pdp-discount-badge] .product-badge--discount');

    if (!entry.active) {
      badges.forEach(function (b) { b.hidden = true; });
      return;
    }

    var tier = pickTier(entry.tiers || [], qty);
    if (!tier) {
      badges.forEach(function (b) { b.hidden = true; });
      return;
    }

    var compareCents = entry.priceCents * qty;
    var saleCents = Math.floor(compareCents * (100 - tier.pct) / 100);
    var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var compareStr = formatMoney(compareCents, moneyFormat);
    var saleStr = formatMoney(saleCents, moneyFormat);

    badges.forEach(function (b) { b.hidden = false; });
    prices.forEach(function (p) { p.innerHTML = saleStr; });
    compares.forEach(function (c) { c.innerHTML = compareStr; });
    badgeLabels.forEach(function (b) { b.textContent = tier.pct + '% OFF'; });
  }

  function getCurrentVariantId() {
    var idInput = document.querySelector('[name="id"]');
    if (!idInput) return null;
    var v = parseInt(idInput.value, 10);
    return isNaN(v) ? null : v;
  }

  document.addEventListener('product:variant-change', function (e) {
    var variant = e && e.detail && e.detail.variant;
    if (!variant) return;
    applyState(variant.id, getCurrentQty());
  });

  document.addEventListener('product:quantity-update', function (e) {
    var d = e && e.detail;
    if (!d || !d.variant) return;
    var qty = parseInt(d.quantity, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    applyState(d.variant.id, qty);
  });

  function bindQuantityInputs() {
    var inputs = document.querySelectorAll('[data-quantity-input]');
    inputs.forEach(function (input) {
      if (input.__discountBadgeBound) return;
      input.__discountBadgeBound = true;
      var handler = function () {
        var vid = getCurrentVariantId();
        if (vid == null) return;
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        applyState(vid, qty);
      };
      input.addEventListener('change', handler);
      input.addEventListener('input', handler);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindQuantityInputs);
  } else {
    bindQuantityInputs();
  }
})();
